import React, { useEffect, useState } from "react"
import { trans } from "@/_providers/Translation"
import { Tab, Tabs } from "@mui/material"
import "@/assets/scss/pages/catalogue.scss"

import Catalogue from "./partials/Catalogue"
import Orders from "./partials/Orders"
import { useAuthDataContext } from "@/_providers/Auth"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"

function Index() {
  const auth = useAuthDataContext()

  const [activeTab, setActiveTab] = useState(1)
  const [hasApiKey, setHasApiKey] = useState(false)
  const [loadingHasApiKey, setLoadingHasApiKey] = useState(true)

  useEffect(() => {
    loadSettings()
  }, [])

  const loadSettings = () => {
    setLoadingHasApiKey(true)

    Api.get("partners/settings/all?id=" + auth.user().partner_id)
      .then((res) => {
        setHasApiKey(!!res.data.aswo_api_key)
      })
      .catch(() => {
        setHasApiKey(false)
      })
      .finally(() => {
        setLoadingHasApiKey(false)
      })
  }

  return (
    <>
      <div id="catalogue" className="wrapper">
        <div className="top-part">
          <div className="left">
            <h1 className="page-heading">{trans("catalogue.heading")}</h1>
            <p className="page-subheading">{trans("catalogue.subheading")}</p>
          </div>
        </div>
        {loadingHasApiKey ? (
          <div className="pannel">
            <Skeleton height={45} count={5} />
          </div>
        ) : hasApiKey ? (
          <>
            <Tabs
              value={activeTab}
              onChange={(e, id) => setActiveTab(id)}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="primary"
              textColor="primary"
              aria-label="catalogue tabs"
            >
              <Tab value={1} label={trans("catalogue.tabCatalogue")} />
              <Tab value={2} label={trans("catalogue.tabOrders")} />
            </Tabs>

            {activeTab === 1 && <Catalogue />}
            {activeTab === 2 && <Orders />}
          </>
        ) : (
          <div
            className="alert warning"
            style={{
              marginBottom: 0,
              width: "100%",
            }}
          >
            {trans("catalogue.missingApiKey")}
          </div>
        )}
      </div>
    </>
  )
}

export default Index
